/**
 * Runtime configuration.
 *
 * Vite inlines `VITE_*` at build time, which was fine while Vercel rebuilt the
 * project per environment. A container image is built once and promoted across
 * stage → testnet → mainnet, so the values cannot live in the bundle.
 *
 * The container entrypoint runs `envsubst` over `public/config.template.js` and
 * writes `/config.js`, which assigns `window.__APP_CONFIG__` before the bundle
 * loads. In dev the committed `public/config.js` is empty and the accessors fall
 * back to `import.meta.env.VITE_*` from `.env`, so `yarn dev` is unchanged.
 */

declare global {
  interface Window {
    __APP_CONFIG__?: {
      API_ENDPOINT?: string
      ENVIRONMENT?: string
      SENTRY_DSN?: string
    }
  }
}

const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}

const pick = (
  runtimeValue: string | undefined,
  buildValue: string | undefined,
) => {
  const v = runtimeValue?.trim()
  // An unsubstituted `${VITE_…}` placeholder means envsubst did not run — treat
  // it as unset rather than letting the literal string reach a fetch or Sentry.
  return v && !v.startsWith('${') ? v : buildValue
}

export const API_ENDPOINT =
  pick(runtime.API_ENDPOINT, import.meta.env.VITE_API_ENDPOINT) ??
  'https://beam.stage.fluence.dev'

export const ENVIRONMENT = pick(
  runtime.ENVIRONMENT,
  import.meta.env.VITE_ENVIRONMENT,
)

export const SENTRY_DSN = pick(
  runtime.SENTRY_DSN,
  import.meta.env.VITE_SENTRY_DSN,
)

export {}
